import React, { useState, useEffect } from 'react';
import { Select, Button } from 'antd';
import { getMachinesApi } from 'redux/api/machineApi';
import Translated from 'components/Translated';
import { searchSelectProps, getTranslated } from 'utils';

const Machine = ({ history, locale, setOperatorMachine }) => {
    const [machines, setMachines] = useState({ selected: undefined, loading: false, data: [] });

    useEffect(() => {
        (async () => {
            setMachines(state => ({ ...state, loading: true }));
            const result = await getMachinesApi({ offset: 0, limit: 999 });
            setMachines(state => ({ ...state, loading: false, data: result.data.hits }));
        })();
    }, []);

    function handleChange(value) {
        setMachines(state => ({ ...state, selected: value }));
    }

    function handleSave() {
        const { name } = machines.data.find(m => m._id === machines.selected);
        setOperatorMachine({ machine: machines.selected, name });

        if ([process.env.REACT_APP_MACHINE_CUTTING, process.env.REACT_APP_MACHINE_COATING].includes(machines.selected)) {
            history.push('/pp/rolls_out/');
        } else if (process.env.REACT_APP_MACHINE_SEWING === machines.selected) {
            history.push('/pp/job_results/');
        } else { 
            history.push('/pp/form_versions/');
        }
    }

    return (
        <section className="gx-mb-3">
            <div className="gx-mb-1">
                <Translated id="formVersion.machine" className="gx-pb-2 gx-d-block gx-fs-sm" />
                <Select
                    {...searchSelectProps}
                    loading={machines.loading}
                    size="large"
                    placeholder={getTranslated('global.select', locale)}
                    onSelect={handleChange}
                    onDeselect={handleChange}
                    className="gx-mb-3 gx-w-100"
                    value={machines.selected}
                    showArrow
                >
                    {machines.data.map(machine => (
                        <Select.Option key={machine._id}>{machine.name}</Select.Option>
                    ))}
                </Select>
            </div>

            <Button
                htmlType="button"
                type="primary"
                className="gx-mb-0"
                onClick={handleSave}
            >
                <i className="la la-save la-lg" />&nbsp;
                <Translated id="global.save" />
            </Button>
        </section>
    );
};

export default Machine;
